import { logWrapper } from '../utils';

function droppableDirectiveFactory(runtimeConstant) {
  function link(scope, element) {
    if (scope.droppable !== true) return;

    const el = element[0];

    function preventDefaults(e) {
      e.preventDefault?.();
      e.stopPropagation?.();
    }

    function handleDragOver(e) {
      preventDefaults(e);
      e.dataTransfer.dropEffect = 'move';
      el.classList.add('over');
      return false;
    }

    function handleDragEnter(e) {
      preventDefaults(e);
      el.classList.add('over');
      return false;
    }

    function handleDragLeave(e) {
      preventDefaults(e);
      el.classList.remove('over');
      return false;
    }

    function handleDrop(e) {
      preventDefaults(e);
      el.classList.remove('over');

      if (el.classList.contains('drag')) return;

      const rawData = e.dataTransfer.getData('Text');
      const idFolder = el.getAttribute('fid');
      const type = rawData.includes('docs') ? 'docs' : 'folder';

      const ids = rawData.replace(`${type}:`, '').split(';').map(Number);

      scope.$apply(() => {
        const fn = scope.drop?.();
        if (typeof fn !== 'undefined') {
          fn(idFolder, ids, type);
        }
      });

      return false;
    }

    el.addEventListener('dragover', handleDragOver, false);
    el.addEventListener('dragenter', handleDragEnter, false);
    el.addEventListener('dragleave', handleDragLeave, false);
    el.addEventListener('drop', handleDrop, false);
  }

  function run() {
    return {
      scope: {
        droppable: '=',
        drop: '&',
        bin: '=',
      },
      link,
    };
  }

  return logWrapper(run, runtimeConstant.isDebugDirectives)();
}

export const droppableDirective = ['runtimeConstant', droppableDirectiveFactory];
